import { useTranslation } from 'react-i18next';
import FeedbackTemplatePage from '../../components/FeedbackTemplatePage/FeedbackTemplatePage';

const NotFoundPage = () => {
    const { t } = useTranslation(['notFoundPage']);

    return <FeedbackTemplatePage status="404" title={t('title')} subTitle={t('subTitle')} />;
};

export default NotFoundPage;
